/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Movement_Current_LeaderInputs */

const en_directory_vibebids_movement_current_leader = /** @type {(inputs: Directory_Vibebids_Movement_Current_LeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current leader`)
};

const zh_directory_vibebids_movement_current_leader = /** @type {(inputs: Directory_Vibebids_Movement_Current_LeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前领先`)
};

/**
* | output |
* | --- |
* | "Current leader" |
*
* @param {Directory_Vibebids_Movement_Current_LeaderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_movement_current_leader = /** @type {((inputs?: Directory_Vibebids_Movement_Current_LeaderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Movement_Current_LeaderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_movement_current_leader(inputs)
	return zh_directory_vibebids_movement_current_leader(inputs)
});
export { directory_vibebids_movement_current_leader as "directory.vibebids.movement_current_leader" }